import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const Seo = ({ lang, bodyClass, seoData, location }) => {
  const twitterUserName = '@VISARTECH'
  const ogImageData =
    // eslint-disable-next-line react/prop-types
    seoData.ogImage && seoData.ogImage.sourceUrl
  const twImageData =
    // eslint-disable-next-line react/prop-types
    seoData.ogImage && seoData.ogImage.localFile.childImageSharp.resize.src
  return (
    <Helmet bodyAttributes={{ class: bodyClass }} htmlAttributes={{ lang }}>
      {seoData.seoTitle && <title>{seoData.seoTitle}</title>}

      {seoData.seoDescription && (
        <meta name="description" content={seoData.seoDescription} />
      )}
      {seoData.seoKeywords && (
        <meta name="keywords" content={seoData.seoKeywords} />
      )}
      <meta
        property="og:url"
        content={`https://www.visartech.com${location.pathname}`}
      />
      <meta property="og:site_name" content="Visartech" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seoData.seoTitle} />
      <meta property="og:description" content={seoData.seoDescription} />

      {seoData.ogImage && <meta property="og:image" content={ogImageData} />}
      {seoData.ogImage && (
        <meta property="og:image:alt" content={seoData.ogImage.altText} />
      )}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content="https://www.visartech.com" />
      <meta name="twitter:site" content={twitterUserName} />
      <meta name="twitter:creator" content={twitterUserName} />
      {seoData.seoTitle && (
        <meta name="twitter:title" content={seoData.seoTitle} />
      )}
      {seoData.seoDescription && (
        <meta name="twitter:description" content={seoData.seoDescription} />
      )}
      {seoData.ogImage && <meta name="twitter:image" content={twImageData} />}
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: 'en',
  bodyClass: '',
}

Seo.propTypes = {
  lang: PropTypes.string,
  bodyClass: PropTypes.string,
  seoData: PropTypes.shape({
    ogImage: PropTypes.shape({
      altText: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
    seoDescription: PropTypes.string,
    seoKeywords: PropTypes.string,
    seoTitle: PropTypes.string,
    twImage: PropTypes.shape({}),
  }).isRequired,
}

export default Seo
